import axios from "axios";

// Por defecto hablamos con el proxy del mismo origen:
// - En desarrollo: `setupProxy.js` redirige a `localhost:3005`
// - En Docker/Nginx: `nginx.conf` redirige a `estudiojuridico-whatsapp:3005`
// Se puede sobrescribir explícitamente con `REACT_APP_WHATSAPP_MS_URL` si hace falta.
const WHATSAPP_MS_BASE_URL = "/whatsapp-ms";

const whatsappMicroserviceClient = axios.create({
  baseURL: WHATSAPP_MS_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 10000
});

const getHealth = async () => {
  const response = await whatsappMicroserviceClient.get("/health");
  return response.data;
};

const getLogs = async (limit = 300) => {
  const response = await whatsappMicroserviceClient.get("/logs", {
    params: { limit }
  });

  if (Array.isArray(response.data)) {
    return response.data;
  }

  return response.data?.data || [];
};

const getQr = async () => {
  const response = await whatsappMicroserviceClient.get('/qr');
  return response.data?.data || {};
};

const reconnect = async () => {
  const response = await whatsappMicroserviceClient.post('/reconnect');
  return response.data;
};

const logout = async () => {
  const response = await whatsappMicroserviceClient.post('/logout');
  return response.data;
};

const getConfig = async () => {
  const response = await whatsappMicroserviceClient.get('/config');
  return response.data?.data || null;
};

const saveConfig = async (payload) => {
  const response = await whatsappMicroserviceClient.post('/config', payload);
  return response.data?.data || null;
};

const sendMessage = async ({ phone, message, tramiteId = null }) => {
  const body = { phone, message };
  if (tramiteId != null) body.tramiteId = tramiteId;
  const response = await whatsappMicroserviceClient.post("/send-message", body);
  return response.data;
};

const whatsappMicroserviceService = {
  getHealth,
  getLogs,
  sendMessage,
  getQr,
  reconnect,
  logout,
  getConfig,
  saveConfig
};

export default whatsappMicroserviceService;
